import { useState } from "react";
import InputField from "components/fields/InputField";
import { apiPost } from "lib/apiClient";

const MIN_LENGTH = 10;

export default function ChangePasswordForm({ variant, currentLabel = "Current password", submitLabel = "Change password", onChanged }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    setDone(false);
    if (!current || !next) return setError("Fill in every field.");
    if (next.length < MIN_LENGTH) return setError(`Use at least ${MIN_LENGTH} characters.`);
    if (next === current) return setError("Choose a password different from the one you are replacing.");
    if (next !== confirm) return setError("The new passwords do not match.");
    setBusy(true);
    try {
      await apiPost("/portal/auth/change-password", { currentPassword: current, newPassword: next });
      setCurrent("");
      setNext("");
      setConfirm("");
      setDone(true);
      if (onChanged) await onChanged();
    } catch (err) {
      setError(err.message || "Could not change the password.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} noValidate>
      <InputField variant={variant} extra="mb-3" label={currentLabel} id="current-password" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} />
      <InputField
        variant={variant}
        extra="mb-3"
        label="New password"
        placeholder={`At least ${MIN_LENGTH} characters`}
        id="new-password"
        type="password"
        value={next}
        onChange={(e) => setNext(e.target.value)}
      />
      <InputField variant={variant} extra="mb-3" label="Confirm new password" id="confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
      {error && <p className="mb-3 text-sm font-medium text-red-500">{error}</p>}
      {done && <p className="mb-3 text-sm font-medium text-green-600">Password changed. Your other devices were signed out.</p>}
      <button
        type="submit"
        disabled={busy}
        className="mt-1 inline-flex h-10 w-full items-center justify-center rounded-sm bg-primary px-6 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-60"
      >
        {busy ? "Saving…" : submitLabel}
      </button>
    </form>
  );
}
